module.exports = __webpack_public_path__ + "img/teacher_women.5aa3d3a6.png";